import React from 'react';
import { FaUserCheck, FaUserTimes, FaUsers, FaUserGraduate, FaChartBar } from 'react-icons/fa';
import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell } from 'recharts';
import { format } from 'date-fns';

export default function DashboardStudents({ studentStats, newAdmissions }) {
  return (
    <div className="dashboard-content">
      {/* Student Metrics */}
      <div className="metrics-grid">
        <div className="metric-card students">
          <div className="metric-icon"><FaUsers /></div>
          <div className="metric-info">
            <p className="metric-label">Total Students</p>
            <h2 className="metric-value">{studentStats?.totalStudents || 0}</h2>
          </div>
        </div>
        <div className="metric-card success">
          <div className="metric-icon"><FaUserCheck /></div>
          <div className="metric-info">
            <p className="metric-label">Active Students</p>
            <h2 className="metric-value">{studentStats?.activeStudents || 0}</h2>
          </div>
        </div>
        <div className="metric-card warning">
          <div className="metric-icon"><FaUserTimes /></div>
          <div className="metric-info">
            <p className="metric-label">Inactive Students</p>
            <h2 className="metric-value">{studentStats?.inactiveStudents || 0}</h2>
          </div>
        </div>
        <div className="metric-card info">
          <div className="metric-icon"><FaUsers /></div>
          <div className="metric-info">
            <p className="metric-label">Transport Users</p>
            <h2 className="metric-value">{studentStats?.transportUsers || 0}</h2>
          </div>
        </div>
      </div>
      {/* Student Charts */}
      <div className="charts-row">
        <div className="chart-card large">
          <div className="chart-header">
            <h3><FaChartBar /> Class-wise Student Distribution</h3>
          </div>
          <div className="chart-body">
            <ResponsiveContainer width="100%" height={280}>
              <BarChart 
                data={Object.entries(studentStats?.classDistribution || {}).map(([cls, count]) => ({
                  class: cls,
                  students: count
                })).sort((a, b) => {
                  const order = ['NUR', 'KG1', 'KG2', 'STD1', 'STD2', 'STD3', 'STD4', 'STD5', 'STD6', 'STD7', 'STD8', 'STD9', 'STD10', 'STD11', 'STD12'];
                  return order.indexOf(a.class) - order.indexOf(b.class);
                })}
              >
                <CartesianGrid strokeDasharray="3 3" stroke="#ecf0f1" />
                <XAxis dataKey="class" stroke="#7f8c8d" />
                <YAxis stroke="#7f8c8d" />
                <Tooltip />
                <Legend />
                <Bar dataKey="students" fill="#3498db" name="Number of Students" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div className="chart-card">
          <div className="chart-header">
            <h3><FaUsers /> Gender Distribution</h3>
          </div>
          <div className="chart-body">
            <ResponsiveContainer width="100%" height={280}>
              <PieChart>
                <Pie
                  data={[
                    { name: 'Male', value: studentStats?.genderDistribution?.Male || 0 },
                    { name: 'Female', value: studentStats?.genderDistribution?.Female || 0 }
                  ]}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, value, percent }) => `${name}: ${value} (${(percent * 100).toFixed(0)}%)`}
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                >
                  <Cell fill="#3498db" />
                  <Cell fill="#e74c3c" />
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
      {/* New Admissions Widget */}
      <div className="widgets-row">
        <div className="widget-card full-width">
          <div className="widget-header">
            <h3><FaUserGraduate /> Recent Admissions (Last 7 Days)</h3>
          </div>
          <div className="widget-body">
            {newAdmissions.length > 0 ? (
              <div className="admissions-grid">
                {newAdmissions.map((student) => {
                  // Safely format admission date
                  let formattedDate = 'N/A';
                  try {
                    if (student.admissionDate) {
                      const date = new Date(student.admissionDate);
                      if (!isNaN(date.getTime())) {
                        formattedDate = format(date, 'MMM dd, yyyy');
                      }
                    }
                  } catch (error) {
                    console.error('Error formatting date:', error);
                  }
                  return (
                    <div key={student.rno} className="admission-card">
                      <div className="admission-avatar">
                        <FaUserGraduate />
                      </div>
                      <div className="admission-info">
                        <h4>{student.name}</h4>
                        <p>Roll No: {student.rno}</p>
                        <p>Class: {student.class}</p>
                        <p className="admission-date">{formattedDate}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="no-data">No new admissions in the last 7 days</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
